module.exports = __webpack_public_path__ + "img/comfortaa-v27-latin-600.ba706b4e.svg";